//#region Imports
import { AUTH_HEADER, createMetaHeaders, SETTINGS_API_ORIGIN_URL, TaskRecord } from "@anydo/core";
import { TaskSyncLogic } from "../sync-logics/TaskSyncLogic";
import type { ITaskDto } from "../types/sync-types";
//#endregion

//#region Types
interface IResponse {
  data: readonly ITaskDto[];
  is_last_page: boolean;
}
//#endregion

export async function fetchSyncHttpDoneTasks(authToken: string, page = 0, signal?: AbortSignal) {
  const url = new URL(SETTINGS_API_ORIGIN_URL + "/me/completed_tasks");
  url.searchParams.set("page", String(page));

  const response = await fetch(url.toString(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      [AUTH_HEADER]: authToken,
      ...createMetaHeaders(),
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(`fetchSyncHttpDoneTasks(): ${response.status} - ${await response.text()}`);
  }

  const data = (await response.json()) as IResponse;

  if (!Array.isArray(data.data)) {
    throw new TypeError(`fetchSyncHttpDoneTasks(): expected array but received '${typeof data}'`);
  }

  const doneTasks = [];

  for (let dto of data.data) {
    doneTasks.push(TaskRecord.create(TaskSyncLogic.mapDtoToModel(dto, undefined)));
  }

  return {
    doneTasks,
    isLastPage: data.is_last_page,
  };
}
